import { deleteObject, getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";
import { edDeptInfoSlide, emptySlide } from "models/EdDeptInfoSlide";
import React, { useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { storage } from "services";
import { MultiplePhotoUploader, PhotoUploader } from "../PhotoUploader";

interface AddEditEdDeptInfoModalProps {
  /** Whether the modal should be shown. */
  show: boolean;

  setShow: React.Dispatch<React.SetStateAction<boolean>>;

  /** Function to be called when canceling or closing the modal. */
  /** The alum to edit, or undefined if creating a new alum. */
  currentSlide: edDeptInfoSlide | undefined;

  /** whether the modal is for multiple upload */
  multipleSlideUpload: boolean;
}

export function AddEditEdDeptInfoModal({
  show,
  setShow,
  currentSlide,
  multipleSlideUpload,
}: AddEditEdDeptInfoModalProps): JSX.Element {
  // eslint-disable-next-line
  const [editedSlide, setEditedSlide] = useState<edDeptInfoSlide>(
    currentSlide ? { ...currentSlide } : { ...emptySlide },
  );
  const [uploadedPhoto, setUploadedPhoto] = useState<File | undefined>(undefined);
  const [uploadedPhotos, setUploadedPhotos] = useState<File[] | undefined>(undefined);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const [validated, setValidated] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const deleteAllSlide = () => {
    const edDeptInfoRef = ref(storage, "edDeptInfoSlide/");
    listAll(edDeptInfoRef)
      .then(function (result) {
        result.items.forEach(function (imageRef) {
          getDownloadURL(imageRef).then(function (url) {
            deleteObject(imageRef);
            console.log(url);
          });
        });
      });
  };

  /**
   * This method will handle submit action
   * It would check whether multiple slides are being uploaded then upload slides accordingly
   */
  async function submitSlide(event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) {
    const form = event.currentTarget;
    // Check if required field has been filled
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault(); // prevents the page from reloading immediately on submit

      /** Check if multiple slides are being uploaded
       * If yes, delete all the existing slides and then replace them with new slides
       * If not, simply add the uploaded slides to the current carousel
       */
      if (multipleSlideUpload === true && uploadedPhotos) {
        deleteAllSlide();
        uploadedPhotos.forEach(photo => {
          const photoRef = ref(storage, `edDeptInfoSlide/${photo.name}`);
          uploadBytes(photoRef, photo);
        });
      } else if (uploadedPhoto) {
        const photoRef = ref(storage, `edDeptInfoSlide/${uploadedPhoto.name}`);
        uploadBytes(photoRef, uploadedPhoto);
      } else {
        history.push("/education-department-info");
      }
      history.push("/education-department-info");

      setIsSubmitting(true);
    }
    setValidated(true);
  }

  /** If user choose to upload multiple slides all at once or update all of the slide  */

  if (multipleSlideUpload === true) {
    return (
      <>
        <Modal show={show}>
          <Form noValidate validated={validated} onSubmit={submitSlide}>
            <Modal.Header>
              <Modal.Title>Add New Set of Slides</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Row>
                  <Col>
                    <Form.Label>Upload Slides</Form.Label>
                    <MultiplePhotoUploader onDrop={(photos: File[]) => setUploadedPhotos(photos)} />
                  </Col>
                </Form.Row>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={handleClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button variant="outline-primary" type="submit" disabled={isSubmitting}>
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }

  /** If not, user can upload one slide at a time */
  return (
    <Modal show={show}>
      <Form noValidate validated={validated} onSubmit={submitSlide}>
        <Modal.Header>
          <Modal.Title>Add New Individual Slide</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Row>
              <Col>
                <Form.Label>Upload Slide</Form.Label>
                <PhotoUploader onDrop={(photos: File[]) => setUploadedPhoto(photos[0])} />
              </Col>
            </Form.Row>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>

          <Button
            variant="outline-primary"
            type="submit"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
